import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {AppBar, Toolbar, Hidden, IconButton, Typography} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import InputIcon from '@material-ui/icons/Input';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import { signOut } from '../../../../apis/api';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    logo: {
        width: '200px',
        display: 'block'
    },
    flexGrow: {
        flexGrow: 1,
    },
    saveButton: {
        color: theme.palette.text.primary,
        marginLeft: theme.spacing(1),
    },
    saveText: {
        marginLeft: theme.spacing(1),
        color: theme.palette.text.primary,
    },
    signOutButton: {
        color: theme.palette.text.primary,
        marginLeft: theme.spacing(1),
    },
    signOutText: {
        color: theme.palette.text.primary,
        marginLeft: theme.spacing(1),
    },
    menuButton: {
        color: theme.palette.text.primary
    }
}));

const resizeImage = (img, maxWidth, maxHeight) => {
    const width = img.width * 0.264583;
    const height = img.height * 0.264583;
    let ratio = 0;

    if (width > maxWidth) {
        ratio = maxWidth / width;
        img.setAttribute('width', maxWidth);
        img.setAttribute('height', width * ratio);
    }

    if (height > maxHeight) {
        ratio = maxHeight / height;
        img.setAttribute('height', maxHeight);
        img.setAttribute('width', width * ratio);
    }
};

const saveToPdf = () => {
    const targetEl = document.querySelector('main');
    const options = {
        bgcolor: '#ffffff'
    };

    domtoimage.toPng(targetEl, options)
        .then((dataUrl) => {
            const img = new Image();
            const doc = new jsPDF('l', 'mm', 'a4');
            const doc_width = doc.internal.pageSize.getWidth();
            const doc_height = doc.internal.pageSize.getHeight();

            img.src = dataUrl;
            img.onload = () => {
                let x = 0;

                resizeImage(img, doc_width, doc_height);
                x = (doc_width - img.width) / 2;
                doc.addImage(img, 'PNG', x, 0, img.width, img.height);
                doc.save(`${document.title}.pdf`);
            };
        });
};

const handleSignOut = event => {
    event.preventDefault();

    signOut()
        .then((res) => {
            if (res.logout) {
                window.location.href = '/sign-in';
            }
        }).catch((error) => {
            console.log(error);
        });
};

const Topbar = props => {
    const {className, onSidebarOpen, ...rest} = props;
    const classes = useStyles();

    return (
        <AppBar
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Toolbar>
                <RouterLink to="/">
                    <img
                        alt="ECDI"
                        className={classes.logo}
                        src="/images/logos/ecbi_logo_fullname.png"
                    />
                </RouterLink>
                <div className={classes.flexGrow}/>
                <Hidden mdDown>
                    <IconButton
                        className={classes.saveButton}
                        onClick={saveToPdf}
                    >
                        <SaveAltIcon/>
                        <Typography variant="button" className={classes.saveText}>
                            Save
                        </Typography>
                    </IconButton>
                    <IconButton
                        // component={RouterLink} to="/sign-in"
                        className={classes.signOutButton}
                        onClick={handleSignOut}
                    >
                        <InputIcon/>
                        <Typography
                            variant="button"
                            className={classes.signOutText}
                        >
                            SIGN OUT
                        </Typography>
                    </IconButton>
                </Hidden>
                <Hidden lgUp>
                    <IconButton
                        className={classes.menuButton}
                        onClick={onSidebarOpen}
                    >
                        <MenuIcon/>
                    </IconButton>
                </Hidden>
            </Toolbar>
        </AppBar>
    );
};

Topbar.propTypes = {
    className: PropTypes.string,
    onSidebarOpen: PropTypes.func,
};

export default Topbar;
